import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  DatePicker,
  Form,
  FullScreenLoading,
  TimePicker,
} from "src/Components";
import { IHistoryConfig } from "src/Interfaces/history";
import { getHistoryConfig, setHistoryConfig } from "src/Requests/history";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onClose: () => void;
}

const Config = ({ onClose }: IProps) => {
  const [formValues, setFormValues] = useState({} as IHistoryConfig);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getHistoryConfig()
      .then((resp) => {
        setFormValues(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (name: string, value: any) => {
    if (name !== "time") setFormValues({ ...formValues, [name]: value });
    else
      setFormValues({
        ...formValues,
        [name]: value.timeString,
        [`${name}ISO`]: value.ISOString,
      });
  };
  const submitHandler = () => {
    setLoading(true);
    setHistoryConfig({
      ...formValues,
      date: formValues.date?.split("T")[0],
    })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onClose();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {loading ? <FullScreenLoading /> : <></>}
      <DatePicker
        value={formValues.date}
        label="تاریخ"
        name="date"
        onChange={changeHandler}
      />
      <TimePicker
        name="time"
        value={formValues.timeISO}
        onChange={changeHandler}
        placeholder="ساعت"
      />
      <Button
        text="ثبت"
        onClick={submitHandler}
        variant="contained"
        disabled={!formValues.date || !formValues.time}
      />
    </Form>
  );
};

export default Config;
